import { useContext, useEffect, useState } from "react"
import { AbsoluteContainer, AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, RemeberMeContainer } from "src/style"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { AppCenterPopup, CenterPopupHeader } from "src/component"
import { useNavigate } from "react-router-dom"
import { BiCheck } from "react-icons/bi"

export const TermsAndCondition: React.FC<any> = ({close}) => {
    const navigate = useNavigate()
    const {info: {termsAndConditions_Privacy, institutionData}} = useContext(AppInfoContext)
    const [content, setContent] = useState('')
    const [type, setType] = useState('terms_conditions')
    const [isRemember, setIsRemember] = useState(false)
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        //if (termsAndConditions_Privacy?.termsAndConditions) setContent(termsAndConditions_Privacy.termsAndConditions) // Using the text config 
        if (institutionData?.termsAndConditionsUrl) setContent(institutionData.termsAndConditionsUrl)
    }, [termsAndConditions_Privacy, institutionData])

    function handleNext () {
        if (type === 'terms_conditions') {
            setType('privacy_policy')
            //setContent(termsAndConditions_Privacy.privacyPolicy) // Using the text config
            setContent(institutionData?.privacyPolicyUrl)
            const date = new Date()
            localStorage.setItem('@tcDate', date.toString())
        }
        else navigate('/onboarding/bvn-verification')
    }

    return (
        <AppCenterPopup close={close} height='52.5' >
            <CenterPopupHeader close={close} />
            <CustomContainer height="41" className='popup-content-container'>
                <CustomContainer topMargin="1.5">
                    <AppText textSize="2.2" fontWeight="700" color="#000000" align="center" bottomMargin="1.5">
                        {type === 'terms_conditions' ? 'Terms & Conditions' : 'Privacy Policy'}
                    </AppText>
                    {/* {
                        content?.split('%%')?.map((item: string, index: number) => {
                            return (
                                <AppText key={index} topMargin={index > 0 ? '1.5': '0'}>{item}</AppText>
                            )
                        })
                    } */}
                    { isLoading &&
                        <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full">
                            <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                                <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                            </GridContainer>
                        </AbsoluteContainer>
                    }
                    <CustomContainer height="28">
                        <iframe 
                            src={content}
                            width='100%' height='100%'
                            frameBorder="0"
                            allowFullScreen
                            onLoad={() => setIsLoading(false)}
                        />
                    </CustomContainer>
                    { type === 'terms_conditions' &&
                        <FlexRow width='auto' sizeUnit='' justifyContent='flex-start' topMargin="1">
                            <RemeberMeContainer 
                                className={`remember-checkbox ${isRemember && 'isremember-me'}`}
                                onClick={() => setIsRemember(!isRemember)}
                            >
                                {isRemember ? <AppSpan color='#0D968F' textSize='1.5' topMargin='-0.3'><BiCheck className='checkbox-icon' /></AppSpan> : null}
                            </RemeberMeContainer>
                            <AppText leftPadding='1'>I Agree</AppText>
                        </FlexRow>
                    }
                    <Button 
                        width='100' sizeUnit='%' topMargin='2' 
                        borderColor='#0D968F' hoverBgColor='#fff' 
                        hoverColor='#0D968F'
                        onClick={handleNext}
                        className='app-action-btn'
                        disabled={type === 'terms_conditions' && !isRemember}
                    >
                        {
                            type === 'terms_conditions' ? 'Continue' : 'Accept and Continue'
                        }
                    </Button>
                </CustomContainer>
           </CustomContainer>
        </AppCenterPopup>
    )
}